import { render, staticRenderFns } from "./CatalogSubject.vue?vue&type=template&id=728a2862&scoped=true"
import script from "./CatalogSubject.vue?vue&type=script&lang=js"
export * from "./CatalogSubject.vue?vue&type=script&lang=js"
import style0 from "./CatalogSubject.vue?vue&type=style&index=0&id=728a2862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a2862",
  null
  
)

export default component.exports